// Basename-aware URL helper. Mirrors the pattern used by the admin
// app so we can sub-path the portal later if needed without rewriting
// fetch calls. With base = "/" today it just returns the input.

const BASE = (import.meta.env.BASE_URL || "/").replace(/\/+$/, "");

export function apiPath(path: string): string {
  return BASE + "/" + path.replace(/^\/+/, "");
}
